const clientkey = 'g#/Nx8,Tj\'mY\'7e:M"M=3df,gz$?{yx,xf(PrTs6'

export { clientkey };